(ns practitest.frontend.common-old-fe.color-pickers
  (:require
    ["react-color" :as react-color]
    [goog.object :as gobj]
    [reagent.core :as r]))

(def alpha-picker (r/adapt-react-class (.-AlphaPicker react-color)))
(def block-picker (r/adapt-react-class (.-BlockPicker react-color)))
(def chrome-picker (r/adapt-react-class (.-ChromePicker react-color)))
(def circle-picker (r/adapt-react-class (.-CirclePicker react-color)))
(def compact-picker (r/adapt-react-class (.-CompactPicker react-color)))
(def github-picker (r/adapt-react-class (.-GithubPicker react-color)))
(def hue-picker (r/adapt-react-class (.-HuePicker react-color)))
(def material-picker (r/adapt-react-class (.-MaterialPicker react-color)))
(def photoshop-picker (r/adapt-react-class (.-PhotoshopPicker react-color)))
(def sketch-picker (r/adapt-react-class (.-SketchPicker react-color)))
(def slider-picker (r/adapt-react-class (.-SliderPicker react-color)))
(def swatches-picker (r/adapt-react-class (.-SwatchesPicker react-color)))
(def twitter-picker (r/adapt-react-class (.-TwitterPicker react-color)))
(def custom-picker (r/adapt-react-class (.-CustomPicker react-color)))

(defn popup-picker [default-color on-set extra-padding left-pos save-action]
  (let [display-color-picker (r/atom false)
        state (r/atom default-color)]
    (fn [_ _ _]
      [:div.row
       {:style {:padding extra-padding}}
       [:div.col-12
        {:style    {:padding       "5px"
                    :background    "#EEF1F2"
                    :border-radius "1px"
                    :box-shadow    "0 0 0 1px rgba(0, 0, 0, .1)"
                    :display       "flex"
                    :align-items   "flex-end"
                    :cursor        "pointer"}
         :on-click #(swap! display-color-picker not)}
        [:div.col-2.pr-0.pl-0
         {:style {:margin-top    "1px"
                  :height        "18px"
                  :border-radius "2px"
                  :border        "#D2D3D3"
                  :border-width  "1px"
                  :border-style  "solid"
                  :background    @state
                  :display       "inline-block"}}]
        [:div.col-10.pl-15
         {:style {:display       "inline-block"}}
         @state]]
       (when @display-color-picker
         [:div
          {:style {:position "fixed"
                   :z-index  6
                   :top "50%"}
           :class left-pos}
          [:div
           {:style    {:position "fixed"
                       :top      "0px"
                       :right    "0px"
                       :bottom   "0px"
                       :left     "0px"}
            :on-click (fn [_]
                        (on-set @state)
                        (reset! display-color-picker false)
                        (save-action))}]
          [compact-picker
           {:color     @state
            :on-change (fn [color event]
                         (reset! state (gobj/get color "hex")))}]])])))
